import(/* webpackMode: "eager" */ "/app/apps/ashkalit/app/[locale]/not-found.tsx");
